import {CONFIG} from '@freckle/educator-entities/ts/common/config'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import ApiRoutesFancy from '@freckle/educator-entities/ts/common/routers/api-routes-fancy'
import {getEnvironment} from '@freckle/educator-entities/ts/config/environment'

const API_URL = PATHS.unversionedAPIUrl

const fancyPaths = ApiRoutesFancy.createPaths(API_URL)

const CommonApiHelper = {
  fancyPaths,
}

export function checkInternetConnectivity(
  pingUrl: string,
  normalRetryPeriod: number,
  failedRetryPeriod: number,
  // eslint-disable-next-line @typescript-eslint/ban-types
  successCallback: Function,
  // eslint-disable-next-line @typescript-eslint/ban-types
  failureCallback: Function
) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const tryReachability: Function = () => {
    $.ajax({
      url: pingUrl,
      type: 'GET',
      // If we're in the middle of destroying the session, we don't
      // want a concurrent request to resurrect it. This is rare, but
      // it can keep a deleted teacher logged in.
      xhrFields: {
        withCredentials: false,
      },
      data: {commitTimestamp: CONFIG.COMMIT_UNIX_TIMESTAMP, commitSHA: CONFIG.COMMIT_SHA},
    })
      .done(() => {
        successCallback()
        setTimeout(tryReachability, normalRetryPeriod)
      })
      .fail(() => {
        failureCallback()
        // switch to rapid retry mode when the connection is down and prevent
        // user from interacting with the application until it's over
        setTimeout(tryReachability, failedRetryPeriod)
      })
  }

  // try to reach our servers every x secs to validate connection health
  setTimeout(tryReachability, normalRetryPeriod)
}

export function checkLoginStatus(
  retryPeriod: number,
  isOnValidUnloggedUrl: () => boolean,
  defaultLoginPageRetries: number
) {
  const checkAuth = (loginPageRetries?: number | null): void => {
    if (isOnValidUnloggedUrl()) {
      const retriesLeft =
        loginPageRetries === null || loginPageRetries === undefined
          ? defaultLoginPageRetries
          : loginPageRetries - 1
      if (retriesLeft > 0) {
        setTimeout(() => checkAuth(retriesLeft), retryPeriod)
      } else {
        document.location.reload()
        setTimeout(checkAuth, retryPeriod)
      }
    } else {
      $.ajax({
        url: fancyPaths.v2.auth_check(),
        type: 'HEAD',
      })
        .done(() => {
          setTimeout(checkAuth, retryPeriod)
        })
        .fail(() => {
          document.location.reload()
          setTimeout(checkAuth, retryPeriod)
        })
    }
  }
  setTimeout(checkAuth, retryPeriod)
}

export function isProductionEnv(): boolean {
  return getEnvironment(window.location.hostname) === 'production'
}

export function isStaging(): boolean {
  return getEnvironment(window.location.hostname) === 'staging'
}

export function isTestEnv(): boolean {
  return getEnvironment(window.location.hostname) === 'test'
}

export function isLocalhost(): boolean {
  return getEnvironment(window.location.hostname) === 'localhost'
}

export default CommonApiHelper
